<div mat-dialog-title class="flex-container">
    <button mat-button class="close" [mat-dialog-close]="true">
      <mat-icon>close</mat-icon>
    </button>
    <h1>Assigning Target - {{assignedScheduler.schedulerName}}</h1>
  </div>
  <div mat-dialog-content>
    <form [formGroup]="_assignTarget">
      <div class="row">
        <div class="col-lg-6">
          <p>Client</p>
          <mat-form-field appearance="none" class="manage-select disable">
            <mat-select formControlName="selectedClient" (selectionChange)="getProjects($event)"
              placeholder="Select Client" required>
              <mat-option *ngFor="let client of clients" [value]="client.clientId">{{ client.clientName }}
              </mat-option>
            </mat-select>
          </mat-form-field>
        </div>
        <div class="col-lg-6">
          <p>Project</p>
          <mat-form-field appearance="none" class="manage-select disable">
            <mat-select formControlName="selectedProject" placeholder="Select Project" required>
              <mat-option *ngFor="let project of projects" [value]="project.projectId">{{ project.projectName }}
              </mat-option>
            </mat-select>
          </mat-form-field>
        </div>
      </div>

      <div class="row">
        <div class="col-lg-6">
          <p>Select Date<span>*</span></p>
          <mat-form-field appearance="none" class="manage-input">
            <mat-date-range-input [rangePicker]="picker" [dateFilter]="rangeFilter">
              <input matStartDate placeholder="Start date" (dateChange)="dateChangeEvent('startDate', $event)">
              <input matEndDate placeholder="End date" (dateChange)="dateChangeEvent('endDate', $event)">
            </mat-date-range-input>
            <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
            <mat-date-range-picker #picker></mat-date-range-picker>
          </mat-form-field>

        </div>
        <div class="col-lg-6"></div>
      </div>

      <div class="row">
        <div class="col-lg-6">
          <p>Call Per Hour <span>*</span></p>
          <mat-form-field appearance="none" class="manage-input">
            <input matInput type="number" min="0" placeholder="Call Per Hour" formControlName="targetCalls" required>
          </mat-form-field>
        </div>

        <div class="col-lg-6">
          <p>Scheduling Per Hour <span>*</span></p>
          <mat-form-field appearance="none" class="manage-input">
            <input matInput type="number" min="0" placeholder="Scheduling Per Hour" formControlName="targetSchedules"
              required>
          </mat-form-field>
        </div>
      </div>

      <div class="row">
        <div class="col-lg-12 toparea">
            <button mat-raised-button mat-button (click)="onSubmit()" [disabled]="!_assignTarget.valid" class="btn btn-icon-text3 md-button-right">
            ASSIGN TARGET
            </button>
        </div>
      </div>
    </form>
  </div>
